import ".././style/OrderHistoryComponent.css";
import { useNavigate } from "react-router-dom";
import useViewport from "../hooks/useViewport";
import { useTranslation } from 'react-i18next';
import { useCurrency } from "../contexts/CurrencyContext";

const OrderHistoryComponent = ({ orderItems, page }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { isVeryMobileView } = useViewport();
    const { formatPrice } = useCurrency();

    const sortedOrders = [...orderItems].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

    return (
        <div>
            {sortedOrders.map((order) => {
                const items = Array.isArray(order.metadata)
                    ? order.metadata.map((item) => JSON.parse(item))
                    : [];

                return (
                    <div key={order.id} className="order-container">
                        <h3>{t("history.dateLabel")}: {new Date(order.created_at).toLocaleDateString()}</h3>
                        <h3>{t("history.numberLabel")}: #{order.order_number}</h3>
                        <h3>{t("history.statusLabel")}: {order.status}</h3>
                        <button
                            className="profile-edit-button"
                            onClick={() => navigate(`/order/${order.order_number}`, { state: { order } })}
                        >
                            {t("history.viewInvoiceLabel")}
                        </button>
                        <ul>
                            {items.map((item, index) => (
                                <li key={index} className="order-item">
                                    <img className="cart-image-preview cart-image-phone" src={item.previewUrl} alt={item.name} />
                                    <div className="order-item-details">
                                        <p className="order-item-name"><strong>{item.name}</strong></p>
                                        {!isVeryMobileView ? (
                                            <div className={`order-details ${page === "Update" ? "order-details-history" : ""}`}>
                                            <p>{t("checkout.priceLabel")}: {item.symbol || "$"}{formatPrice(item.totalPrice, item.currency || "CAD")} {item.currency || "CAD"}</p> |
                                            <p>{t("checkout.sizeLabel")}: {t("options.size" + item.selectedSize) || "N/A"}</p> |
                                            {item.selectedFirmness && item.selectedFirmness !== "N/A" && (
                                                <p>
                                                    {t("checkout.softnessLabel")}: {typeof item.selectedFirmness?.description === "string"
                                                    ? t("options.firmness" + item.selectedFirmness.description).replace(/Firmness|Souplesse/gi, "").trim()
                                                    : t("options.firmness" + item.selectedFirmness) || "N/A"} |
                                                </p>
                                            )}
                                            {item.selectedColor && item.selectedColor !== "N/A" && (
                                                <p>{t("checkout.colorLabel")}: {item.selectedColor || "N/A"} | </p>
                                            )}
                                            <p>{t("checkout.optionsLabel")}: {item.selectedOption ? t("options.option" + item.selectedOption): t("checkout.noneLabel")}</p>
                                        </div>
                                        ) : (
                                            <div className={`order-details ${page === "Update" ? "order-details-history" : ""}`}>
                                            <p>{t("checkout.priceLabel")}: {item.symbol || "$"}{formatPrice(item.totalPrice, item.currency || "CAD")} {item.currency || "CAD"}</p>
                                            <p>{t("checkout.sizeLabel")}: {t("options.size" + item.selectedSize) || "N/A"}</p>
                                            {item.selectedFirmness && item.selectedFirmness !== "N/A" && (
                                                <p>
                                                    {t("checkout.softnessLabel")}: {typeof item.selectedFirmness?.description === "string"
                                                    ? t("options.firmness" + item.selectedFirmness.description).replace(/Firmness|Souplesse/gi, "").trim()
                                                    : t("options.firmness" + item.selectedFirmness) || "N/A"}
                                                </p>
                                            )}
                                            {item.selectedColor && item.selectedColor !== "N/A" && (
                                                <p>{t("checkout.colorLabel")}: {item.selectedColor || "N/A"} | </p>
                                            )}
                                            <p>{t("checkout.optionsLabel")}: {item.selectedOption ? t("options.option" + item.selectedOption) : t("checkout.noneLabel")}</p>
                                        </div>
                                        )}
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                );
            })}
        </div>
    );
};

export default OrderHistoryComponent;
